export enum SelectedOption {
  ALL = "All",
  OPENED = "Opened"
}
